import React from "react"
import { FaCheckCircle, FaInfoCircle, FaTimesCircle } from "react-icons/fa"

export type ToastType = "success" | "error" | "info"

interface ThemeToastProps {
  type: ToastType
  text1: string
  text2?: string
  emojiIcon?: string
  iconName?: "success" | "error" | "info"
  onClose?: () => void
  showCloseButton?: boolean
  buttonText?: string
  onButtonClick?: () => void
}

const iconMap = {
  success: (
    <div className="h-8 w-8 bg-green-500/20 rounded-full flex items-center justify-center">
      <FaCheckCircle className="text-green-500 text-xl" />
    </div>
  ),
  error: (
    <div className="h-8 w-8 bg-red-500/20 rounded-full flex items-center justify-center">
      <FaTimesCircle className="text-red-500 text-xl" />
    </div>
  ),
  info: (
    <div className="h-8 w-8 bg-blue-500/20 rounded-full flex items-center justify-center">
      <FaInfoCircle className="text-blue-500 text-xl" />
    </div>
  ),
}

const ThemeToast: React.FC<ThemeToastProps> = ({
  type,
  text1,
  text2,
  emojiIcon,
  iconName,
  onClose,
  showCloseButton,
  buttonText,
  onButtonClick,
}) => {
  return (
    <div className="px-4 py-3 backdrop-blur-sm bg-black/60 flex items-center justify-center -mx-1.5 -mt-1.5">
      <div className="flex mr-3 self-center">
        {emojiIcon ? (
          <span className="text-2xl">{emojiIcon}</span>
        ) : (
          iconMap[iconName ?? type]
        )}
      </div>
      <div className={`flex-1 text-left ${!showCloseButton && "mr-3"}`}>
        <div className="text-white font-semibold">{text1}</div>
        {text2 && <div className="text-gray-300 text-sm mt-0.5">{text2}</div>}
        {buttonText && onButtonClick && (
          <div className="mt-3">
            <button
              onClick={onButtonClick}
              className="bg-gray-500/50 hover:bg-gray-500/70 text-white font-semibold py-1.5 px-4 rounded-lg text-sm"
            >
              {buttonText}
            </button>
          </div>
        )}
      </div>
    </div>
  )
}

export default ThemeToast
